<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="active"
      style="background:transparent"
    >
      <!-- Payroll -->
      <v-tab-item>
        <v-autocomplete
          v-model="payrollELetter"
          label="E Letter Types"
          :items="payrollELetterTypes"
          item-text="name"
          class="pt-5 px-3"
          autofocus
          style="background:white"
        />
        <payroll-e-letter-bonus-letter
          v-if="payrollELetter === 'Bonus Letters'"
          class="mb-2"
        />
        <payroll-e-letter-increment-letter
          v-if="payrollELetter === 'Increment Letters'"
          class="mb-2"
        />
        <payroll-e-letter-promotion-letter
          v-if="payrollELetter === 'Promotion Letters'"
          class="mb-2"
        />        
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
  export default {
    components: {
      PayrollELetterIncrementLetter: () => import('@/components/hris/payroll/e-letter/IncrementLetter'),
      PayrollELetterBonusLetter: () => import('@/components/hris/payroll/e-letter/BonusLetter'),
      PayrollELetterPromotionLetter: () => import('@/components/hris/payroll/e-letter/PromotionLetter'),
    },

    data () {
      return {
        tabItems: [
          { name: 'E Letters' },
        ],
        active: 0,

        payrollELetter: null,
        payrollELetterTypes: [
          { name: 'Bonus Letters' },
          { name: 'Increment Letters' },
          { name: 'Promotion Letters' },
        ],
      }
    },
  }
</script>
